module.exports = __webpack_public_path__ + "img/maria.8f46a7b4.png";